export interface Category {
  id: string;
  name: string;
  desc: string;
  count: number;
  icon: string;
  cover: string;
}

export interface Work {
  id: string;
  title: string;
  categoryId: string;
  categoryName: string;
  status: "连载中" | "已完结";
  rating: number;
  chapters: number;
  popularity: number;
  tags: string[];
  cover: string;
  summary: string;
}

export const categories: Category[] = [
  {
    id: "sweet",
    name: "甜宠浪漫",
    desc: "心动瞬间与双向奔赴的甜蜜故事",
    count: 128,
    icon: "ri-heart-3-line",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20sweet%20romance%20young%20couple%20sharing%20umbrella%20in%20spring%20rain%20warm%20pink%20and%20coral%20tones%20soft%20dreamy%20lighting%20detailed%20anime%20illustration%20romantic%20atmosphere%20cinematic%20high%20quality%20no%20text&width=600&height=800&seq=cat-sweet&orientation=portrait",
  },
  {
    id: "fantasy",
    name: "奇幻冒险",
    desc: "异世界与魔法大陆的壮阔征程",
    count: 96,
    icon: "ri-sparkling-2-line",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20fantasy%20adventure%20hero%20holding%20glowing%20sword%20in%20ancient%20ruins%20emerald%20teal%20and%20gold%20palette%20magical%20particles%20dramatic%20epic%20composition%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=cat-fantasy&orientation=portrait",
  },
  {
    id: "mystery",
    name: "悬疑烧脑",
    desc: "层层反转的谜局与真相追踪",
    count: 74,
    icon: "ri-magic-line",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20mystery%20thriller%20silhouette%20of%20detective%20in%20dark%20apartment%20corridor%20dim%20amber%20and%20charcoal%20tones%20tense%20moody%20atmosphere%20dramatic%20shadows%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=cat-mystery&orientation=portrait",
  },
  {
    id: "urban",
    name: "都市现实",
    desc: "都市生活与职场成长的真实写照",
    count: 83,
    icon: "ri-building-2-line",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20modern%20city%20street%20young%20professional%20walking%20at%20dusk%20warm%20amber%20and%20cream%20tones%20city%20lights%20bokeh%20realistic%20slice%20of%20life%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=cat-urban&orientation=portrait",
  },
  {
    id: "action",
    name: "热血动作",
    desc: "酣畅淋漓的打斗与少年热血",
    count: 68,
    icon: "ri-flashlight-line",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20dynamic%20action%20young%20fighter%20in%20mid%20kick%20energy%20bursts%20coral%20orange%20and%20warm%20gold%20palette%20explosive%20motion%20speed%20lines%20dramatic%20angle%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=cat-action&orientation=portrait",
  },
  {
    id: "school",
    name: "校园青春",
    desc: "象牙塔里的欢笑与悸动",
    count: 91,
    icon: "ri-graduation-cap-line",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20school%20youth%20students%20under%20cherry%20blossom%20tree%20on%20campus%20soft%20pink%20and%20mint%20pastel%20tones%20fresh%20bright%20sunny%20mood%20playful%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=cat-school&orientation=portrait",
  },
  {
    id: "historical",
    name: "古风宫廷",
    desc: "权谋较量的古风传奇",
    count: 62,
    icon: "ri-goblet-line",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20historical%20palace%20elegant%20noblewoman%20in%20traditional%20hanbok%20in%20ornate%20royal%20garden%20rich%20red%20gold%20and%20cream%20palette%20luxurious%20detailed%20costume%20anime%20illustration%20dramatic%20lighting%20high%20quality%20no%20text&width=600&height=800&seq=cat-historical&orientation=portrait",
  },
  {
    id: "healing",
    name: "治愈日常",
    desc: "慢节奏的温暖与生活小确幸",
    count: 57,
    icon: "ri-cup-line",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20cozy%20daily%20life%20coffee%20cup%20and%20sleeping%20cat%20by%20window%20with%20plants%20warm%20cream%20beige%20and%20terracotta%20tones%20soft%20gentle%20sunlight%20calm%20healing%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=cat-healing&orientation=portrait",
  },
];

export const works: Work[] = [
  {
    id: "moonlight-promise",
    title: "月光下的约定",
    categoryId: "sweet",
    categoryName: "甜宠浪漫",
    status: "已完结",
    rating: 9.5,
    chapters: 120,
    popularity: 986,
    tags: ["双向奔赴", "治愈", "青梅竹马"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20sweet%20romance%20young%20couple%20sitting%20on%20rooftop%20under%20warm%20full%20moon%20soft%20coral%20pink%20and%20warm%20orange%20sky%20dreamy%20romantic%20glow%20detailed%20anime%20illustration%20cinematic%20high%20quality%20no%20text&width=600&height=800&seq=work-01&orientation=portrait",
  },
  {
    id: "heartbeat-signal",
    title: "心动信号",
    categoryId: "sweet",
    categoryName: "甜宠浪漫",
    status: "连载中",
    rating: 9.2,
    chapters: 68,
    popularity: 874,
    tags: ["办公室恋情", "甜腻", "追妻"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20romance%20two%20characters%20sending%20text%20messages%20phone%20glow%20warm%20pink%20and%20cream%20background%20cute%20heart%20motifs%20flirty%20cheerful%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-02&orientation=portrait",
  },
  {
    id: "book-of-mirage",
    title: "幻境之书",
    categoryId: "fantasy",
    categoryName: "奇幻冒险",
    status: "连载中",
    rating: 9.4,
    chapters: 95,
    popularity: 921,
    tags: ["异世界", "魔法", "组队冒险"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20fantasy%20mage%20girl%20opening%20glowing%20ancient%20book%20in%20floating%20library%20emerald%20teal%20and%20gold%20magic%20particles%20epic%20wonder%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-03&orientation=portrait",
  },
  {
    id: "starwalker",
    title: "星穹行者",
    categoryId: "fantasy",
    categoryName: "奇幻冒险",
    status: "已完结",
    rating: 9.0,
    chapters: 142,
    popularity: 802,
    tags: ["星际", "热血", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20space%20adventure%20young%20astronaut%20floating%20in%20nebula%20with%20shooting%20stars%20warm%20gold%20and%20deep%20teal%20palette%20vast%20cosmic%20scale%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-04&orientation=portrait",
  },
  {
    id: "mist-apartment",
    title: "迷雾公寓",
    categoryId: "mystery",
    categoryName: "悬疑烧脑",
    status: "连载中",
    rating: 9.6,
    chapters: 48,
    popularity: 989,
    tags: ["推理", "惊悚", "多重反转"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20mystery%20dramatic%20doorway%20with%20fog%20in%20apartment%20hallway%20deep%20charcoal%20and%20dim%20amber%20light%20tense%20eerie%20atmosphere%20sharp%20shadows%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-05&orientation=portrait",
  },
  {
    id: "countdown-maze",
    title: "倒计时谜局",
    categoryId: "mystery",
    categoryName: "悬疑烧脑",
    status: "已完结",
    rating: 9.1,
    chapters: 76,
    popularity: 753,
    tags: ["密室", "智商对决", "烧脑"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20mystery%20game%20master%20in%20dark%20room%20with%20glowing%20digital%20timer%20charcoal%20and%20warm%20orange%20accents%20suspenseful%20intense%20mood%20dramatic%20lighting%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-06&orientation=portrait",
  },
  {
    id: "city-light",
    title: "城市之光",
    categoryId: "urban",
    categoryName: "都市现实",
    status: "已完结",
    rating: 8.8,
    chapters: 108,
    popularity: 731,
    tags: ["职场", "现实向", "成长"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20urban%20drama%20young%20woman%20looking%20at%20city%20skyline%20from%20office%20window%20at%20night%20warm%20city%20lights%20amber%20and%20cream%20tones%20realistic%20thoughtful%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-07&orientation=portrait",
  },
  {
    id: "late-night-diary",
    title: "深夜食堂日记",
    categoryId: "urban",
    categoryName: "都市现实",
    status: "连载中",
    rating: 9.3,
    chapters: 54,
    popularity: 845,
    tags: ["美食", "人情味", "温暖"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20warm%20night%20food%20stall%20steaming%20bowl%20of%20noodles%20cozy%20lamplight%20terracotta%20and%20gold%20tones%20comforting%20homely%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-08&orientation=portrait",
  },
  {
    id: "burning-campus",
    title: "热血高校",
    categoryId: "school",
    categoryName: "校园青春",
    status: "连载中",
    rating: 9.0,
    chapters: 88,
    popularity: 812,
    tags: ["社团", "友情", "热血"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20school%20youth%20energetic%20boy%20in%20sporty%20pose%20with%20friends%20on%20campus%20field%20vibrant%20orange%20and%20mint%20tones%20bright%20sunny%20dynamic%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-09&orientation=portrait",
  },
  {
    id: "cherry-season",
    title: "樱色季节",
    categoryId: "school",
    categoryName: "校园青春",
    status: "已完结",
    rating: 8.9,
    chapters: 96,
    popularity: 766,
    tags: ["初恋", "唯美", "青春"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20school%20romance%20girl%20with%20flowing%20hair%20under%20cherry%20blossom%20petals%20soft%20pink%20and%20cream%20pastel%20tones%20gentle%20dreamy%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-10&orientation=portrait",
  },
  {
    id: "phoenix-empire",
    title: "凤临天下",
    categoryId: "historical",
    categoryName: "古风宫廷",
    status: "连载中",
    rating: 9.2,
    chapters: 110,
    popularity: 878,
    tags: ["权谋", "复仇", "大女主"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20historical%20empress%20in%20splendid%20traditional%20robe%20with%20phoenix%20motif%20in%20royal%20court%20rich%20red%20gold%20and%20cream%20palette%20authoritative%20majestic%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-11&orientation=portrait",
  },
  {
    id: "splendid-rivers",
    title: "锦绣山河",
    categoryId: "historical",
    categoryName: "古风宫廷",
    status: "已完结",
    rating: 8.7,
    chapters: 132,
    popularity: 698,
    tags: ["乱世", "家国", "群像"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20historical%20general%20overlooking%20mountain%20river%20battlefield%20at%20sunset%20deep%20red%20amber%20and%20earth%20tones%20epic%20widescreen%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-12&orientation=portrait",
  },
  {
    id: "spring-letter",
    title: "春日来信",
    categoryId: "healing",
    categoryName: "治愈日常",
    status: "连载中",
    rating: 9.1,
    chapters: 42,
    popularity: 739,
    tags: ["温暖", "手写信", "慢生活"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20cozy%20healing%20scene%20handwritten%20letter%20and%20dried%20flowers%20on%20wooden%20desk%20by%20window%20soft%20spring%20light%20warm%20cream%20beige%20and%20terracotta%20tones%20gentle%20soothing%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-13&orientation=portrait",
  },
  {
    id: "coffee-and-cat",
    title: "咖啡与猫",
    categoryId: "healing",
    categoryName: "治愈日常",
    status: "已完结",
    rating: 8.9,
    chapters: 60,
    popularity: 715,
    tags: ["萌宠", "咖啡店", "治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20cozy%20cafe%20barista%20with%20fluffy%20cat%20on%20counter%20warm%20cappuccino%20and%20caramel%20tones%20soft%20morning%20light%20calm%20heartwarming%20mood%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-14&orientation=portrait",
  },
  {
    id: "obsidian-operation",
    title: "曜石行动",
    categoryId: "action",
    categoryName: "热血动作",
    status: "连载中",
    rating: 9.3,
    chapters: 72,
    popularity: 867,
    tags: ["特工", "刺激", "高燃"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20agent%20action%20stealthy%20spy%20in%20black%20gear%20with%20weapon%20amid%20explosions%20charcoal%20and%20electric%20orange%20accents%20intense%20high%20octane%20mood%20dramatic%20lighting%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-15&orientation=portrait",
  },
  {
    id: "backlight-boy",
    title: "逆光少年",
    categoryId: "action",
    categoryName: "热血动作",
    status: "已完结",
    rating: 8.6,
    chapters: 104,
    popularity: 644,
    tags: ["格斗", "逆袭", "兄弟情"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20street%20martial%20artist%20silhouette%20against%20sunset%20backlight%20warm%20gold%20and%20coral%20sky%20powerful%20determined%20pose%20dramatic%20rim%20light%20detailed%20anime%20illustration%20high%20quality%20no%20text&width=600&height=800&seq=work-16&orientation=portrait",
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Vibrant%20Korean%20manhwa%20webtoon%20art%20collage%20background%20colorful%20comic%20style%20artwork%20with%20dynamic%20characters%20and%20floating%20comic%20panels%20warm%20coral%20teal%20and%20amber%20palette%20artistic%20abstract%20composition%20soft%20depth%20energetic%20modern%20high%20detail%20no%20text&width=1600&height=900&seq=hero-manhwa&orientation=landscape";

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "什么是正版韩漫？",
    a: "正版韩漫是指获得原作者或版权方正式授权的韩语漫画中文版作品。我们坚持收录正规授权内容，尊重每一位创作者的心血，让你看得安心又省心。",
  },
  {
    q: "首页的分类与榜单多久更新一次？",
    a: "分类内容与热门榜单每天都会自动刷新，结合人气值、评分与完读率综合排序，确保你打开的每一页都能看到最新的热门韩漫推荐。",
  },
  {
    q: "如何快速找到想看的题材？",
    a: "你可以在「分类」页面按甜宠、奇幻、悬疑、热血等题材筛选，也可以在首页直接浏览人气推荐，或在榜单页查看近期热度最高的作品，三分钟告别选择困难。",
  },
  {
    q: "作品的状态和章节数准确吗？",
    a: "我们会实时同步连载进度，标注『连载中』与『已完结』两种状态，并显示当前章节数，方便你合理安排阅读节奏。",
  },
  {
    q: "如何收藏我喜欢的故事？",
    a: "在作品卡片点击收藏按钮即可加入个人追漫列表，后续可通过页面顶部的追更入口快速回到上次阅读的位置。",
  },
];